import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=24f0d35f&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=ts"
export * from "./AgentList.vue?vue&type=script&lang=ts"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=24f0d35f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0d35f",
  null
  
)

export default component.exports